module.exports = __webpack_public_path__ + "img/electronic_electric_no_zone.d64a98b2.svg";